<script>
import {nextTick} from "vue";

export default {
    name: 'InputRangeBetween',

    emits: ['filter-updated', 'update:model-value'],

    props: {
        min: {
            type: Number
        },
        max: {
            type: Number
        },
        step: {
            type: Number

        },
        label: {
            type: String
        },
        attr: {
            type: String
        },
        filter: {
            type: String
        },
        iconMin: {
            type: String
        },
        iconMax: {
            type: String
        },
        format: {
            type: String
        },
        prefixFrom: {
            type: String
        },
        prefixTo: {
            type: String
        },
    },

    data: function () {
        return {
            range: [],
            valueMin : 0,
            valueMax : 0,
        };
    },

    created() {
        // console.log('create '+this.filter);
        setTimeout(this.updateRange, 500)
        // nextTick(this.updateRange);
    },
    mounted() {
        // console.log('mount '+this.filter);
    },

    watch: {
        min(newValue) {
            // console.log('new current min: '+newValue);
            // console.log(this.valueMin);
            if (newValue !== this.valueMin) {
                this.setValueMin(this.min);
                this.updateRange();
            }
        },

        max(newValue) {
            // console.log('new current max: '+newValue);
            // console.log(this.valueMax);
            if (newValue !== this.valueMax) {
                this.setValueMax(newValue);
                this.updateRange();
            }
        }
    },

    computed: {
        disabled() {
            return this.min === this.max ;
        },

        uniqueId() {
            const id = Math.floor(Math.random() * 100 + 1);
            return this.attr + `-${id}`;
        },

        minWidthBg() {
            return this.disabled ?
                "100%" :
                ((this.getValueMin() - this.min) / (this.max - this.min)) * 100 + "%";
        },

        maxWidthBg() {
            return this.disabled ?
                "100%" :
                ((this.max - this.getValueMax()) / (this.max - this.min)) * 100 + "%";
        },
    },

    methods: {
        formatRange(input) {
            if (this.format === "integer") {
                return parseInt(input);
            } else if (this.format === "currency") {
                return new Intl.NumberFormat("nb-NO", {
                    style: "decimal",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(parseInt(input));
            }
        },

        valueMinChanged() {
            // console.log('- valueMinChanged: '+this.getValueMin());
            if (this.getValueMin() >= this.getValueMax()) {
                this.setValueMax(this.getValueMin());
            }

            this.updateRange();
        },

        valueMaxChanged() {
            if (this.getValueMax() <= this.getValueMin()) {
                this.setValueMin(this.getValueMax());
            }

            this.updateRange();
        },

        updateRange() {
            let maxValue = this.getValueMax();

            // >>> dirty hack to fix init value
            this.setValueMax(++maxValue);
            this.setValueMax(--maxValue);
            // <<<

            this.range = [this.getValueMin(), this.getValueMax()];
            this.triggerEmit();
        },

        triggerEmit() {
            if (Number.isInteger(this.range[0]) && Number.isInteger(this.range[1])) {
                // console.log('🤠 triggerEmit: '+this.filter);
                this.$emit("filter-updated", this.filter, this.range, "<= >=");
            }
        },

        getValueMin() {
            return parseInt(this.valueMin);
        },

        setValueMin(value) {
            // console.log(`setValueMin(${value}) | ${this.filter}`);
            this.valueMin = value;
        },

        getValueMax() {
            return parseInt(this.valueMax);
        },

        setValueMax(value) {
            // console.log(`setValueMax(${value}) | ${this.filter}`);
            this.valueMax = value;
        },
    },
}
</script>


<template>

    <div class="input-range-between">
        <div v-if="iconMin && iconMax" class="d-flex space-between mb-4">
            <span class="input-range-between__icon" v-html="iconMin"></span>
            <span class="input-range-between__icon" v-html="iconMax"></span>
        </div>
        <div class="input-range-between__slider">
            <div :style="{ 'width': minWidthBg }" class="input-range-between__slider-min"></div>
            <div :style="{ 'width': maxWidthBg }" class="input-range-between__slider-max"></div>
            <label :for="'min'+uniqueId" class="d-none">{{ label }}</label>
            <input type="range"
                   v-model="valueMin"
                   :id="'min'+uniqueId"
                   :min="min"
                   :max="max"
                   class="form-slider"
                   :step="step"
                   @change="valueMinChanged"
            />
            <label :for="'max'+uniqueId" class="d-none">{{ label }}</label>
            <input type="range"
                   class="form-slider"
                   v-model="valueMax"
                   :id="'max'+uniqueId"
                   :min="min"
                   :max="max"
                   :step="step"
                   @change="valueMaxChanged"
            />
        </div>
        <div class="d-flex text-grey space-between">
            <label :for="'min'+uniqueId">{{prefixFrom}} {{ formatRange(valueMin) }}</label>
            <label :for="'min'+uniqueId">{{prefixTo}} {{ formatRange(valueMax) }}</label>
        </div>
    </div>
</template>